import React from 'react';
import { IIconProps } from './IIconProps';

export const EditIcon = ({
	iconClass = '',
	title = '',
	onClick,
	pointer,
}: IIconProps) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			version="1.1"
			viewBox="0 0 24 24"
			className={`stroke ${iconClass} ${pointer ? 'icon--pointer' : ''}`}
			fill="none"
			onClick={onClick}
		>
			{title && <title>{title}</title>}
			<path d="M4.5 14.9404L15.7333 3.70711L19.2929 7.26667L8.05956 18.5H4.5V14.9404Z" />
		</svg>
	);
};
